import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { ISolicitudAmpliacionSsoModel } from "../interfaces/calendario-sso/ISolicitudAmpliacionSsoModel";

export class SolicitudAmpliacionSsoModel implements ISolicitudAmpliacionSsoModel{
    idSolicitudAmpliacionSso: number;
    anio: number;
    mesSelected?: number;
    mes: number;
    nombreMes: string;
    idContratista?: number;
    contratista: string;
    idSede: number;
    sede?: string;
    idSedeSelected?: number;
    idEstado: number;
    estado: string;
    idTipo: number;
    tipo: string;
    nuevoPlazo?: Date;
    idAprobador: string;
    idSolicitante: string;
    aprobador: string;
    solicitante: string;
    motivo: string;
    idFichaSso?: number;
    idFichaPasst?: number;
    comentarioPorAprobacionRechazo: string;
    aprobado: boolean;
    desaprobado: boolean;
    fechaCreacion?: Date;
    actividad?:string;
    idCompania: number;
    constructor(){
        this.idSolicitudAmpliacionSso = 0;
        this.anio = 0;
        this.mes = 0;
        this.nombreMes = '';
        this.contratista = '';
        this.idSede = 0;
        this.sede = '';
        this.idEstado = 0;
        this.estado = '';
        this.idTipo = 0;
        this.tipo = '';
        this.idAprobador = '';
        this.idSolicitante = '';
        this.aprobador = '';
        this.solicitante = '';
        this.motivo = '';
        this.comentarioPorAprobacionRechazo = '';
        this.aprobado = false;
        this.desaprobado = false;
        this.idCompania = 0;
    }

}